import { useTranslation } from 'react-i18next'
import { Folder, FolderEditParams } from '../../types'
import FormWrapper from '../../ui/form/FormWrapper'
import TextInput from '../../ui/form/TextInput'
import Modal, { ModalProps } from '../../ui/Modal'
import api from '../../api'
import { useContext } from 'react'
import { ProjectContext } from '../../contexts'

type FolderEditModalProps = {
    folder: FolderEditParams
    path: Folder['path']
    onSave?: (folder: Folder) => void
} & Omit<ModalProps, 'title'>

export const FolderEditModal = ({ folder, path, open, onClose, onSave }: FolderEditModalProps) => {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)
    const pathCopy = [...path]
    const pathStr = folder?.id
        ? pathCopy.slice(0, -1).map(f => f.name).join(' / ')
        : pathCopy.map(f => f.name).join(' / ')

    const handleOnSave = async (name: string) => {
        const result = folder?.id
            ? await api.folders.update(project.id, folder.id, { name })
            : await api.folders.create(project.id, { name, parent_id: folder.parent_id, type: folder.type })
        onSave?.(result)
    }

    return (
        <Modal open={open} onClose={onClose} title={t('folder_add')}>
            <TextInput
                name="parent"
                label={t('path')}
                value={pathStr}
                disabled />
            <FormWrapper<Folder>
                onSubmit={async ({ name }) => await handleOnSave(name)}
                defaultValues={folder}
                submitLabel={folder?.id ? t('save') : t('create')}
            >
                {form => (
                    <TextInput.Field
                        form={form}
                        name="name"
                        label={t('name')}
                        required />
                )}
            </FormWrapper>
        </Modal>
    )
}
